import { IMPORT_GROUP_MEMBERS, IMPORT_GROUP_MEMBERS_REQUEST, SETUP_IMPORT_RESULTS_STATE } from './constants'
import config from '../../../../config'

export function importGroupMembers(members, country) {
    return {
        type: IMPORT_GROUP_MEMBERS,
        data: {
            members,
            country,
        },
    }
}

export function importGroupMembersRequest(members, groupId, country) {
    return {
        type: IMPORT_GROUP_MEMBERS_REQUEST,
        payload: {
            ...config.api.groupStack.importGroupMembers,
            qs: {
                id: groupId,
            },
            body: {
                country,
                members,
            },
        },
    }
}

export function setupImportResultsState(importResults, importing, results = {}) {
    return {
        type: SETUP_IMPORT_RESULTS_STATE,
        data: {
            importResults,
            importing,
            results,
        },
    }
}
